interface UserKind {
  name: string;
  description?: string;
  url?: string;
  imageUrl?: string;
  location?: string;
}

export default UserKind;
